import type { FaireProductEntity } from "../../entity_types/product";

export const p_8k343bxac8: FaireProductEntity = {
  token: "p_8k343bxac8",
  type: "product",
  name: "Dainty Star Layering Station Necklace in Stainless Steel",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/16aa592342a515a5eaff9ff98598068ca6b71737e92613f980ec5a20d3f2882c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86ea302132c29133134b2f44c038bf95ca0f4370aab01dc5730efe96f395da6c.jpeg",
    "https://cdn.faire.com/fastly/1571a4b16c9f44b1ad3a904f6bab9b2f2ab752802f4fedb815c530749fb13f07.jpeg",
    "https://cdn.faire.com/fastly/c4e7e7b0c2ab28528d2a1df35c86cf30ab65e6d0a1abc288c5fdab5e738e9979.jpeg",
    "https://cdn.faire.com/fastly/542dcdf59edf430978ed2a6b352969899394ab0d35b08a37135cc53cf3f0edd6.jpeg",
  ],
  priceDollars: 11,
  description:
    "Description & Details\n\nImmerse yourself in the celestial realm with our meticulously crafted pieces, designed to capture the celestial elements in stunning detail. Whether you're drawn to the radiant sun, the mysterious moon, or the twinkling stars, our sun, moon, and star Jewelry will add a celestial touch to your look.\n\n• Material: High Quality Titanium Steel\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 41 - 45 cm chain, adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:47.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
